/**
 * Minimal chrome for PUBLIC pages (privacy, terms) — rendered without the
 * auth gate so they're reachable when signed out (needed for Google OAuth
 * verification, which crawls these URLs unauthenticated).
 */
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from './Footer.tsx';

export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen-dvh pb-16">
      <header className="sticky top-0 z-40 px-4 pt-4">
        <div className="mx-auto max-w-6xl px-1">
          <Link to="/" className="group inline-flex items-center gap-2.5">
            <span className="grid h-10 w-10 shrink-0 place-items-center overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-line">
              <img src="/logo.png" alt="" className="h-full w-full object-contain p-0.5" />
            </span>
            <span className="font-display text-xl font-bold tracking-tight text-fg">
              Bhandari <span className="font-normal text-fg-2">Photos</span>
            </span>
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-6">{children}</main>
      <Footer />
    </div>
  );
}
